<div class="disable-whole-div" [hidden]="!showOverlay" style="overflow: hidden">
  <div fxLayout="row" fxLayoutAlign="center center" class="wrapTopEntStop">
    @if (showUpgradeButton) {
      <button fxFlex="center center" (click)="upgrade()" mat-raised-button color="warn">
        <span class="textPos">
          <mat-icon>add_to_queue</mat-icon>
          <b>{{buttonText}}</b>
        </span>
      </button>
    }
  </div>
</div>
